import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './Loader';
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import ModalAssignTicket from './ModalAssignTicket';
import EstoqueValoresTable from './TicketsSupport/EstoqueValoresTable';
import FichaTecnicaEmpreendimento from './TicketsSupport/FichaTecnicaEmpreendimento';

const EXP_BOLD  = { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 700 };
const EXP_SB    = { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 600 };
const INPUT_FONT = { fontFamily: "'Archivo Expanded', sans-serif", fontStyle: 'normal', fontWeight: 400, fontSize: '19px', color: '#5B595B' };
const BTN_BASE  = { ...EXP_SB, fontSize: '25px', textTransform: 'uppercase', letterSpacing: '0.5px', padding: '14px 28px', borderRadius: 0, border: 'none', cursor: 'pointer' };
const STATUS_BASE = { ...EXP_BOLD, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '2px 12px', borderRadius: 0, fontSize: '17px', lineHeight: 'normal', minWidth: '128px', whiteSpace: 'nowrap', textTransform: 'uppercase', textAlign: 'center', boxSizing: 'border-box' };

// Mesmo padrão visual do modal de Atribuir (ModalAssignTicket.jsx), pra manter os
// modais de ação do chamado (Atribuir / Finalizar) com a mesma aparência.
const MODAL_HR_STYLE = {
    height: 0,
    border: 'none',
    borderTop: '3px solid #f2f2f2',
    margin: '0 25px',
};

const MODAL_BUTTON_STYLE = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: '48px',
    fontFamily: "'Archivo Expanded', sans-serif",
    fontSize: '25px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '8px 25px',
    border: 'none',
    borderRadius: 0,
    cursor: 'pointer',
    backgroundColor: '#B2B2B2',
    color: '#FFFFFF',
};

const S = {
    page: { ...EXP_BOLD },

    label: { ...EXP_BOLD, fontSize: '23px', color: '#5B595B', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' },
    value: { ...EXP_BOLD, fontSize: '16px', color: '#5B595B', marginBottom: '18px' },

    disabledInput: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B', border: '4px solid #F2F2F2', borderRadius: 0, height: '44px', padding: '9px 12px', boxSizing: 'border-box', backgroundColor: '#B2B2B221' },

    sectionLabel: { ...EXP_BOLD, fontSize: '12px', color: '#B2B2B2', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' },

    personRow: { display: 'flex', alignItems: 'center', marginBottom: '20px' },
    personName: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 700, fontSize: '23px', color: '#5B595B' },
    personValue: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B' },

    metaText: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B' },

    statusAberto:   { ...STATUS_BASE, background: '#4D5830', color: '#fff' },
    statusAndamento:{ ...STATUS_BASE, background: '#F3CE00', color: '#4D5830' },
    statusFinalizado:{ ...STATUS_BASE, background: '#4D5A31', color: '#fff' },

    msgSender: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 700, fontSize: '23px', color: '#5B595B', margin: 0, padding: 0 },
    msgText: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B', marginBottom: '8px', marginTop: '25px'  },
    msgDate: { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '23px', color: '#5B595B', margin: 0, padding: 0 , lineHeight: '1.0'},


    attachItem: { display: 'inline-flex' },
};

class ChamadoShow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chamado: null,
            user: null,
            mensagem: '',
            loading: false,
            errors: [],
            show_modal_assign: false,
            observation_status: '',
            show_confirm_finish: false,
        };
        this.mapContainerRef = React.createRef();
        this.mapInstance = null;
        this.markerInstance = null;
        this.mapScriptLoaded = false;
    }

    setLoading = async (loading) => {
        await this.setState({ loading });
    }

    finishChamado = async () => {
        try {
            await this.setLoading(true);
            const response = await axios.post(route('ticket.finish', this.state.chamado.id), {
                observation_status: this.state.observation_status,
            });
            if (response.status === 200) {
                await this.setState({ show_confirm_finish: false, observation_status: '' });
                toast.success('Chamado finalizado com sucesso!');
                this.loadChamado();
            }
        } catch (e) {
            if (e.response && e.response.status === 422) {
                this.setState({ errors: e.response.data.errors });
            }
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    handleAssigned = async () => {
        await this.setState({ show_modal_assign: false });
        toast.success('Chamado atribuído com sucesso!');
        this.loadChamado();
    }

    capturarChamado = async () => {
        try {
            await this.setLoading(true);
            await axios.post(route('ticket.capture', this.state.chamado.id));
            this.loadChamado();
        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    loadGoogleMapsScript = () => {
        if (window.google && window.google.maps) {
            this.initGoogleMap();
            return;
        }
        window._chamadoInitMap = () => {
            this.mapScriptLoaded = true;
            this.initGoogleMap();
        };
        if (!document.getElementById('chamado-gmaps-script')) {
            const script = document.createElement('script');
            script.id = 'chamado-gmaps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${window.GOOGLE_MAPS_KEY || ''}&callback=_chamadoInitMap`;
            script.async = true;
            document.head.appendChild(script);
        }
    }

    initGoogleMap = () => {
        if (!this.mapContainerRef.current || !window.google) return;
        if (this.mapInstance) return;

        const addr = this.state.chamado?.building_address || {};
        const lat = parseFloat(addr.latitude) || -23.5505;
        const lng = parseFloat(addr.longitude) || -46.6333;

        const center = new window.google.maps.LatLng(lat, lng);

        this.mapInstance = new window.google.maps.Map(this.mapContainerRef.current, {
            zoom: 15,
            center,
            scrollwheel: false,
        });

        this.markerInstance = new window.google.maps.Marker({
            position: center,
            map: this.mapInstance,
            draggable: true,
            title: this.state.chamado?.building?.name || 'Empreendimento',
        });

        const infowindow = new window.google.maps.InfoWindow({
            content: `<div><p>Latitude: ${lat}</p><p>Longitude: ${lng}</p></div>`,
        });

        window.google.maps.event.addListener(this.markerInstance, 'dragend', () => {
            const newLat = this.markerInstance.getPosition().lat();
            const newLng = this.markerInstance.getPosition().lng();
            infowindow.setContent(`<div><p>Latitude: ${newLat}</p><p>Longitude: ${newLng}</p></div>`);
        });

        this.markerInstance.addListener('click', () => {
            infowindow.open(this.mapInstance, this.markerInstance);
        });
    }

    updateNavbarBrand = () => {
        const navbarBrand = document.querySelector('#layout_top_bar .navbar-brand');
        if (navbarBrand && this.state.chamado?.id) {
            const wrapper = document.createElement('span');
            wrapper.className = navbarBrand.className;
            wrapper.id = navbarBrand.id;
            wrapper.innerHTML = `<a href="${route('chamados.index')}" class="chamado-titulo">Chamados</a> <span class="chamado-numero">› Chamado #${this.state.chamado.id}</span>`;
            navbarBrand.replaceWith(wrapper);
        }
    }

    loadChamado = async () => {
        const parts = window.location.pathname.split('/');
        const id = parts[parts.length - 1];

        try {
            await this.setLoading(true);
            const response = await axios.get(route('chamado.show.json', id));
            this.setState({ chamado: response.data.ticket, user: response.data.user }, () => {
                if (this.state.chamado?.observation === 'Localização Incorreta' || this.state.chamado?.observation === 'Localização') {
                    this.loadGoogleMapsScript();
                }
                this.updateNavbarBrand();
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                alert('Chamado não encontrado');
                window.location = route('chamados.index');
            }
        } finally {
            await this.setLoading(false);
        }
    }

    sendNewMessage = async () => {
        if (this.state.mensagem.trim() === '') {
            this.setState({ errors: { mensagem: ['O campo mensagem é obrigatório.'] } });
            return;
        }

        try {
            await this.setLoading(true);
            const response = await axios.post(route('chamado.contact', this.state.chamado.id), {
                mensagem: this.state.mensagem,
            });

            if (response.status === 201) {
                this.setState({
                    mensagem: '',
                    errors: [],
                    chamado: { ...this.state.chamado, contacts: response.data },
                });
                toast.success('Mensagem enviada com sucesso!');
            }
        } catch (error) {
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data.errors });
            }
        } finally {
            await this.setLoading(false);
        }
    }

    componentDidMount = async () => {
        await this.loadChamado();
    }

    getStatusBadge = (status) => {
        const styleMap = {
            'Aberto': S.statusAberto,
            'Finalizado': S.statusFinalizado,
            'Em Atendimento': S.statusAndamento,
        };
        const labelMap = {
            'Em Atendimento': 'Andamento',
        };
        return <span style={styleMap[status] || S.statusAberto}>{labelMap[status] || status}</span>;
    }

    getAvatarSrc = (url) => {
        return (url && !url.includes('profile2.png')) ? url : '/img/profile_default_image.png';
    }

    renderAvatar = (user) => {
        const src = this.getAvatarSrc(user?.profile_picture_url);
        return <img src={src} alt={user?.name} width={58} height={58}
            onError={(e) => { e.target.onerror = null; e.target.src = '/img/profile_default_image.png'; }}
            style={{ width: '58px', height: '58px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />;
    }

    getFileThumbnail = (mimeType, filename) => {
        const mimeMap = {
            'image/gif': '/img/thumb_gif.png',
            'image/jpeg': '/img/thumb_jpg.png',
            'image/jpg': '/img/thumb_jpg.png',
            'image/png': '/img/thumb_png.png',
            'application/pdf': '/img/thumb_pdf.png',
            'application/vnd.ms-powerpoint': '/img/thumb_ppt.png',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': '/img/thumb_ppt.png',
            'application/vnd.ms-excel': '/img/thumb_xls.png',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/img/thumb_xls.png',
        };
        if (mimeType && mimeMap[mimeType]) return mimeMap[mimeType];
        const extMap = { gif: '/img/thumb_gif.png', jpg: '/img/thumb_jpg.png', jpeg: '/img/thumb_jpg.png', png: '/img/thumb_png.png', pdf: '/img/thumb_pdf.png', ppt: '/img/thumb_ppt.png', pptx: '/img/thumb_ppt.png', xls: '/img/thumb_xls.png', xlsx: '/img/thumb_xls.png' };
        const ext = filename?.split('.').pop()?.toLowerCase();
        return (ext && extMap[ext]) ? extMap[ext] : null;
    }

    render() {
        const { chamado, user } = this.state;

        if (!chamado) return this.state.loading ? <Loader /> : null;

        const dataAbertura = chamado.created_at
            ? new Date(chamado.created_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
            : '—';
        const dataFinalizacao = chamado.finished_at
            ? new Date(chamado.finished_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
            : null;

        const contatos = chamado.contacts ? [...chamado.contacts] : [];

        const semNumero = chamado.building_address
            ? (!chamado.building_address.numero || String(chamado.building_address.numero).toUpperCase() === 'S/N')
            : false;

        const canAttribute = !!user?.can_gerenciar_tickets;
        const isInternalUser = !!user?.can_gerenciar_tickets;
        // Pedido do cliente: qualquer um da fila de atribuição pode finalizar qualquer
        // chamado, não só o responsável atual dele (igual liberou no backend, ver
        // TicketSuportController::finishTicket). Pra reverter pra "só o responsável
        // atual ou gestor", troca por: user?.id == chamado.current_responsible_id || canAttribute
        const canFinish = chamado.status !== 'Finalizado' && (canAttribute || !!user?.can_atendimento_chamados);
        const canSendMessage =
            chamado.status !== 'Finalizado' &&
            (user?.id == chamado.client_id || user?.id == chamado.current_responsible_id);

        return (
            <div style={S.page}>
                <ModalAssignTicket
                    show={this.state.show_modal_assign}
                    ticket={chamado}
                    user={user}
                    usersRoute={route('chamado.users.fila')}
                    handleAssigned={this.handleAssigned}
                    handleCloseModal={() => this.setState({ show_modal_assign: false })} />

                <style>{`
                    .modal-finish-ticket { max-width: 600px; }
                    .modal-finish-ticket .modal-content { border-radius: 0; }
                `}</style>
                <Modal show={this.state.show_confirm_finish} onHide={() => this.setState({ show_confirm_finish: false })} dialogClassName="modal-finish-ticket" centered>
                    <Modal.Header style={{ border: 'none', padding: '0 30px', paddingTop: 0 }}>
                        <Modal.Title style={{
                            fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                            fontSize: '26px',
                            fontWeight: 700,
                            color: '#5B595B',
                        }}>
                            Finalizar chamado
                        </Modal.Title>
                    </Modal.Header>
                    <hr style={MODAL_HR_STYLE} />
                    <Modal.Body style={{ padding: '28px 24px' }}>
                        <p style={{
                            fontFamily: "'Archivo Expanded', sans-serif", fontSize: '19px',
                            color: '#5B595B', margin: 0,
                        }}>
                            Tem certeza que deseja finalizar o chamado <strong>#{chamado.id}</strong> com status <strong>{this.state.observation_status}</strong>?
                        </p>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '24px' }}>
                            <button
                                style={MODAL_BUTTON_STYLE}
                                onClick={() => this.setState({ show_confirm_finish: false })}
                            >
                                Cancelar
                            </button>
                            <button
                                style={{ ...MODAL_BUTTON_STYLE, backgroundColor: '#CF3C3E' }}
                                onClick={this.finishChamado}
                            >
                                Confirmar
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false}
                    newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover
                    style={{ width: '50%', zIndex: 9999999 }} />

                {this.state.loading && <Loader />}

                <div className="row">
                    {/* ======= Coluna Principal ======= */}
                    <div className="col-md-8">

                        {/* Painel Resumo (inclui Anexos no final) */}
                        <div className="card chamados-card">
                            <div className="card-header chamados-card-header">
                                <h2 className="chamados-subtitle">Resumo do chamado #{chamado.id}</h2>
                            </div>
                            <hr className="chamados-divider" />
                            <div className="card-body chamados-card-body">
                                {/* Linha 1: Assunto + Observação */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Assunto</label>
                                            <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.subject || '—'} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Observação</label>
                                            <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.observation || ''} />
                                        </div>
                                    </div>
                                </div>
                                {/* Linha 2: Cidade + Empreendimento */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Cidade</label>
                                            <input type="text" className="form-control" disabled style={S.disabledInput} value={`${chamado.city || ''}${chamado.state ? ` - ${chamado.state}` : ''}`} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Empreendimento</label>
                                            <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building?.name || chamado.building_name || ''} />
                                        </div>
                                    </div>
                                </div>

                                {/* Anexos dentro do painel resumo */}
                                <span style={{ ...S.label, fontWeight: 600, marginTop: '24px' }}>Anexos</span>
                                <div style={{ marginTop: '8px', marginBottom: '14px', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                                    {chamado.anexos && chamado.anexos.length > 0
                                        ? chamado.anexos.map((a, idx) => {
                                            const thumb = this.getFileThumbnail(a.type, a.name);
                                            return (
                                                <a key={idx} href={a.url} target="_blank" rel="noopener noreferrer" title={a.name} style={S.attachItem}>
                                                    {thumb
                                                        ? <img src={thumb} alt={a.name} title={a.name} style={{ height: '50px', width: 'auto', objectFit: 'contain' }} />
                                                        : <i className="fa fa-paperclip" style={{ fontSize: '50px', color: '#4D5830' }} />}
                                                </a>
                                            );
                                        })
                                        : <p style={{ ...S.value, color: '#B2B2B2' }}>Nenhum anexo.</p>
                                    }
                                </div>

                                {chamado.building_address && (chamado.observation === 'Localização Incorreta' || chamado.observation === 'Localização') && (
                                    <>
                                        <span style={{ ...S.label, marginTop: '24px', marginBottom: '20px' }}>Localização informada pelo solicitante</span>
                                        <div className="row" style={{ marginTop: '10px' }}>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>CEP</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.cep || ''} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Endereço</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.endereco || ''} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Número</label>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <input type="text" className="form-control" disabled style={{ ...S.disabledInput, flex: 1 }} value={semNumero ? '' : (chamado.building_address.numero || '')} />
                                                        <span style={{ display: 'flex', alignItems: 'center', fontWeight: 400, fontSize: '14px', whiteSpace: 'nowrap' }}>
                                                            <input type="checkbox" disabled readOnly checked={semNumero} style={{ marginRight: '4px' }} />
                                                            Sem número
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Bairro</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.bairro || ''} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Cidade</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.cidade || ''} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Estado</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.estado || ''} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Latitude</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.latitude || ''} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Longitude</label>
                                                    <input type="text" className="form-control" disabled style={S.disabledInput} value={chamado.building_address.longitude || ''} />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            ref={this.mapContainerRef}
                                            style={{ width: '100%', height: '220px', marginTop: '8px', borderRadius: '8px', border: '1px solid #F2F2F2', overflow: 'hidden' }}
                                        />
                                    </>
                                )}

                                {(chamado.observation === 'Estoque incorreto' || chamado.observation === 'Estoque' || chamado.observation === 'Valor incorreto' || chamado.observation === 'Preço') &&
                                    chamado.tipologias && chamado.tipologias.length > 0 && (
                                    <EstoqueValoresTable
                                        observacao={chamado.observation}
                                        tipologias={chamado.tipologias}
                                    />
                                )}

                                {chamado.observation === 'Ficha técnica' && chamado.building?.id && (
                                    <FichaTecnicaEmpreendimento buildingId={chamado.building.id} />
                                )}
                            </div>
                        </div>

                        {/* Painel Mensagens */}
                        <div className="card chamados-card">
                            <div className="card-header chamados-card-header">
                                <h2 className="chamados-subtitle">Histórico de contatos</h2>
                            </div>
                            <hr className="chamados-divider" />
                            <div className="card-body chamados-card-body">
                                {/* Enviar nova mensagem */}
                                {canSendMessage && (
                                    <>
                                        <textarea
                                            className={`chamados-mensagem-input ${this.state.errors.mensagem ? 'is-invalid' : ''}`}
                                            onChange={(e) => {
                                                this.setState({ mensagem: e.target.value });
                                                e.target.style.height = 'auto';
                                                e.target.style.height = `${Math.max(150, e.target.scrollHeight)}px`;
                                            }}
                                            value={this.state.mensagem}
                                            style={{
                                                height: '150px', minHeight: '150px', width: '100%', display: 'block',
                                                ...INPUT_FONT,
                                                marginBottom: '4px', borderRadius: 0, border: '4px solid #F2F2F2',
                                                padding: '8px 12px', resize: 'none', outline: 'none',
                                                boxSizing: 'border-box', overflow: 'hidden',
                                            }}
                                            placeholder="Digite sua mensagem..."
                                        />
                                        {this.state.errors['mensagem'] && (
                                            <div className="invalid-feedback" style={{ display: 'block', marginBottom: '6px' }}>
                                                {this.state.errors['mensagem']}
                                            </div>
                                        )}
                                        <div style={{ textAlign: 'right' }}>
                                            <button className="btn-enviar" style={{ marginTop: '20px', marginBottom: '25px', padding: '6px 30px' }} onClick={this.sendNewMessage}>Enviar</button>
                                        </div>
                                    </>
                                )}

                                {/* Histórico — mais novas no topo, mensagem de abertura por último */}
                                {!chamado.message && contatos.length === 0 && (
                                    <p style={{ ...S.value, color: '#B2B2B2' }}>Nenhuma mensagem ainda.</p>
                                )}

                                {[...contatos].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((msg, idx) => {
                                    const dataCriacao = new Date(msg.created_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                                    const senderAvatar = this.getAvatarSrc(msg.sender?.profile_picture_url);
                                    return (
                                        <div key={idx} style={{ position: 'relative', marginLeft: '36px', marginTop: '12px', marginBottom: '20px' }}>
                                            <img
                                                src={senderAvatar}
                                                alt={msg.sender?.name}
                                                style={{
                                                    position: 'absolute', top: '0', left: '-36px',
                                                    width: '72px', height: '72px',
                                                    borderRadius: '50%', objectFit: 'cover',
                                                    zIndex: 1,
                                                }}
                                            />
                                            <div style={{
                                                background: '#EEEFF0', border: 'none',
                                                borderRadius: 0, padding: '10px 16px 14px 44px',
                                            }}>
                                                <div style={{ marginBottom: '6px' }}>
                                                    <div style={S.msgSender}>{msg.sender?.name}</div>
                                                    <div style={S.msgDate}>{dataCriacao}</div>
                                                </div>
                                                <div style={S.msgText}>{msg.message}</div>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Mensagem de abertura — sempre a última */}
                                {chamado.message && (
                                    <div style={{ position: 'relative', marginLeft: '36px', marginTop: '12px', marginBottom: '20px' }}>
                                        <img
                                            src={this.getAvatarSrc(chamado.client?.profile_picture_url)}
                                            alt={chamado.client?.name}
                                            style={{
                                                position: 'absolute', top: '0', left: '-36px',
                                                width: '72px', height: '72px',
                                                borderRadius: '50%', objectFit: 'cover',
                                                zIndex: 1,
                                            }}
                                        />
                                        <div style={{
                                            background: '#EEEFF0', border: 'none',
                                            borderRadius: 0, padding: '10px 16px 14px 44px',
                                        }}>
                                            <div style={{ marginBottom: '6px' }}>
                                                <div style={S.msgSender}>{chamado.client?.name}</div>
                                                <div style={S.msgDate}>
                                                    {new Date(chamado.created_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                                                </div>
                                            </div>
                                            <div style={S.msgText}>{chamado.message}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ======= Coluna Lateral ======= */}
                    <div className="col-md-4">
                        <div className="card chamados-card">
                            <div className="card-body chamados-card-body">
                                {/* Solicitante */}
                                <p style={S.label}>Solicitante</p>
                                <div style={S.personRow}>
                                    <span style={{ marginLeft: '15px' }}>{this.renderAvatar(chamado.client)}</span>
                                    <div style={{ marginLeft: '8px', flex: 1, minWidth: 0 }}>
                                        <div style={{ ...S.personName, overflowWrap: 'break-word' }}>{chamado.client?.name || '—'}</div>
                                        {chamado.client?.empresa?.name && <div style={{ ...S.personValue, overflowWrap: 'break-word' }}>{chamado.client.empresa.name}</div>}
                                        {chamado.client?.email && <div style={{ ...S.personValue, overflowWrap: 'break-word' }}>{chamado.client.email}</div>}
                                    </div>
                                </div>

                                <hr className="chamados-divider" />

                                {/* Atribuído */}
                                <p style={{ ...S.label, marginTop: '20px' }}>Atribuído para</p>
                                <div style={S.personRow}>
                                    <span style={{ marginLeft: '15px' }}>{this.renderAvatar(chamado.responsible)}</span>
                                    <div style={{ marginLeft: '8px', flex: 1, minWidth: 0 }}>
                                        <div style={{ ...S.personName, overflowWrap: 'break-word' }}>{chamado.responsible?.name || 'Não atribuído'}</div>
                                        {chamado.responsible?.email && <div style={{ ...S.personValue, overflowWrap: 'break-word' }}>{chamado.responsible.email}</div>}
                                    </div>
                                </div>

                                {/* Status + Datas lado a lado */}
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexWrap: 'wrap', gap: '64px', marginTop: '30px', marginBottom: '30px' }}>

                                    {/* Coluna da esquerda: Datas */}
                                    <div>
                                        <span style={{ ...S.metaText, fontSize: '23px', fontWeight: 700, display: 'block', marginBottom: '4px' }}>Data de Abertura</span>
                                        <p style={{ ...S.metaText, fontSize: '23px', marginBottom: '12px' }}>{dataAbertura}</p>

                                        <span style={{ ...S.metaText, fontSize: '23px', fontWeight: 700, display: 'block', marginBottom: '4px' }}>Data de Finalização</span>
                                        <p style={{ ...S.metaText, fontSize: '23px', marginBottom: '12px' }}>{dataFinalizacao || ' '}</p>
                                    </div>

                                    {/* Coluna da direita: Status */}
                                    <div style={{ textAlign: 'left' }}>
                                        <span style={{ ...S.metaText, fontWeight: 700, display: 'block', marginBottom: '4px' }}>Status</span>
                                        <div style={{ marginBottom: '14px', marginTop: '4px' }}>
                                        {this.getStatusBadge(chamado.status)}
                                        </div>
                                    </div>

                                </div>



                                {/* Ações de finalização - para quem está na fila de atribuição e para gestores */}
                                {canFinish && (
                                    <>
                                        {/* Botão Atribuir — exclusivo de quem tem permissão de gerenciar tickets (gestor) */}
                                        {canAttribute && (
                                            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                                <div style={{ flex: 1 }} />
                                                <button
                                                    className="btn-anexar"
                                                    style={{ flex: 2 }}
                                                    onClick={() => this.setState({ show_modal_assign: true })}
                                                >
                                                    Atribuir
                                                </button>
                                                <div style={{ flex: 1 }} />
                                            </div>
                                        )}

                                        {/* Status do chamado */}
                                        <div style={{ marginBottom: '20px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                                <span style={{
                                                    fontFamily: "'Archivo Expanded', sans-serif",
                                                    fontSize: '19px', fontWeight: 700, color: '#5B595B',
                                                    whiteSpace: 'nowrap', fontStyle: 'normal',
                                                    WebkitFontSmoothing: 'antialiased',
                                                }}>Status do chamado:</span>
                                                <label style={{
                                                    fontFamily: "'Archivo Expanded', sans-serif",
                                                    fontSize: '23px', fontWeight: 400, color: '#5B595B',
                                                    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', margin: 0,
                                                }}>
                                                    <input
                                                        type="radio" name="observation_status" value="Correto"
                                                        checked={this.state.observation_status === 'Correto'}
                                                        onChange={() => this.setState({ observation_status: 'Correto', show_confirm_finish: false, errors: {} })}
                                                        style={{
                                                            appearance: 'none', WebkitAppearance: 'none',
                                                            width: '20px', height: '20px', flexShrink: 0,
                                                            border: '2px solid #B2B2B2', borderRadius: 0,
                                                            cursor: 'pointer',
                                                            backgroundColor: this.state.observation_status === 'Correto' ? '#4D5830' : '#fff',
                                                        }}
                                                    />
                                                    Correto
                                                </label>
                                                <label style={{
                                                    fontFamily: "'Archivo Expanded', sans-serif",
                                                    fontSize: '23px', fontWeight: 400, color: '#5B595B',
                                                    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', margin: 0,
                                                }}>
                                                    <input
                                                        type="radio" name="observation_status" value="Incorreto"
                                                        checked={this.state.observation_status === 'Incorreto'}
                                                        onChange={() => this.setState({ observation_status: 'Incorreto', show_confirm_finish: false, errors: {} })}
                                                        style={{
                                                            appearance: 'none', WebkitAppearance: 'none',
                                                            width: '20px', height: '20px', flexShrink: 0,
                                                            border: '2px solid #B2B2B2', borderRadius: 0,
                                                            cursor: 'pointer',
                                                            backgroundColor: this.state.observation_status === 'Incorreto' ? '#4D5830' : '#fff',
                                                        }}
                                                    />
                                                    Incorreto
                                                </label>
                                            </div>
                                            {this.state.errors['observation_status'] && (
                                                <div style={{ color: '#CF3C3E', fontSize: '13px', marginTop: '6px', fontFamily: "'Archivo Expanded', sans-serif" }}>
                                                    {this.state.errors['observation_status']}
                                                </div>
                                            )}
                                        </div>

                                        {/* FINALIZAR + CHAMADOS */}
                                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                            <button
                                                className="btn-finalizar"
                                                style={{ flex: '1 1 140px' }}
                                                onClick={() => {
                                                    if (!this.state.observation_status) {
                                                        this.setState({ errors: { observation_status: 'Selecione o status do chamado.' } });
                                                        return;
                                                    }
                                                    this.setState({ show_confirm_finish: true });
                                                }}
                                            >
                                                Finalizar
                                            </button>
                                            <a
                                                href={route('chamados.index')}
                                                className="btn-anexar"
                                                style={{ flex: '1 1 140px', textDecoration: 'none', textAlign: 'center' }}
                                            >
                                                Chamados
                                            </a>
                                        </div>
                                    </>
                                )}

                                {/* Status do chamado (somente leitura) — chamado finalizado, usuário interno */}
                                {chamado.status === 'Finalizado' && isInternalUser && chamado.observation_status && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                            <span style={{
                                                fontFamily: "'Archivo Expanded', sans-serif",
                                                fontSize: '19px', fontWeight: 700, color: '#5B595B',
                                                whiteSpace: 'nowrap', fontStyle: 'normal',
                                                WebkitFontSmoothing: 'antialiased',
                                            }}>Status do chamado:</span>
                                            <label style={{
                                                fontFamily: "'Archivo Expanded', sans-serif",
                                                fontSize: '23px', fontWeight: 400, color: '#5B595B',
                                                display: 'flex', alignItems: 'center', gap: '8px', margin: 0,
                                            }}>
                                                <input
                                                    type="radio" name="observation_status_readonly" value="Correto"
                                                    checked={chamado.observation_status === 'Correto'}
                                                    disabled
                                                    readOnly
                                                    style={{
                                                        appearance: 'none', WebkitAppearance: 'none',
                                                        width: '20px', height: '20px', flexShrink: 0,
                                                        border: '2px solid #B2B2B2', borderRadius: 0,
                                                        backgroundColor: chamado.observation_status === 'Correto' ? '#4D5830' : '#fff',
                                                        opacity: chamado.observation_status === 'Correto' ? 1 : 0.5,
                                                    }}
                                                />
                                                Correto
                                            </label>
                                            <label style={{
                                                fontFamily: "'Archivo Expanded', sans-serif",
                                                fontSize: '23px', fontWeight: 400, color: '#5B595B',
                                                display: 'flex', alignItems: 'center', gap: '8px', margin: 0,
                                            }}>
                                                <input
                                                    type="radio" name="observation_status_readonly" value="Incorreto"
                                                    checked={chamado.observation_status === 'Incorreto'}
                                                    disabled
                                                    readOnly
                                                    style={{
                                                        appearance: 'none', WebkitAppearance: 'none',
                                                        width: '20px', height: '20px', flexShrink: 0,
                                                        border: '2px solid #B2B2B2', borderRadius: 0,
                                                        backgroundColor: chamado.observation_status === 'Incorreto' ? '#4D5830' : '#fff',
                                                        opacity: chamado.observation_status === 'Incorreto' ? 1 : 0.5,
                                                    }}
                                                />
                                                Incorreto
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {/* Botões de navegação — escondidos quando o responsável/gestor já tem o bloco de ações */}
                                {!canFinish && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: (chamado.status === 'Finalizado' && isInternalUser) ? 'flex-end' : 'flex-start' }}>
                                    {(chamado.status === 'Finalizado' && isInternalUser) ? (
                                        <a
                                            href={route('chamados.index')}
                                            className="btn-anexar"
                                            style={{ flex: '0 1 50%', textDecoration: 'none', height: 'auto', padding: '6px', whiteSpace: 'nowrap', textAlign: 'center' }}
                                        >
                                            Chamados
                                        </a>
                                    ) : (<>
                                        <a
                                            href={route('chamados.index')}
                                            className="btn-anexar"
                                            style={{ flex: '1 1 140px', textDecoration: 'none', height: 'auto', padding: '6px', whiteSpace: 'nowrap' }}
                                        >
                                            Chamados
                                        </a>
                                        <a
                                            href={route('chamados.index')}
                                            className="btn-anexar"
                                            style={{ flex: '1 1 140px', textDecoration: 'none', height: 'auto', padding: '6px', whiteSpace: 'nowrap' }}
                                        >
                                            Novo Chamado
                                        </a>
                                    </>)}
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="chamados-footer">
                    <p>© <span className="chamados-footer-semibold">BRAIN INTELIGÊNCIA ESTRATÉGICA</span> <span className="chamados-footer-normal">desenvolvido por</span> <span className="chamados-footer-bold">Belogic</span></p>
                </div>
            </div>
        );
    }
}

export default ChamadoShow;

if (document.getElementById('js-chamado-show')) {
    ReactDOM.render(<ChamadoShow />, document.getElementById('js-chamado-show'));
}
